import { observable, makeObservable, action, toJS, runInAction } from 'mobx';
import { obsDownloadFile } from '../utils/obsService';
import { setAnswerApi, submitExamApi, requestExamPracticeApi, startExamApi, getMyAnswerApi, getAnswerInfoApi, getPaperPreviewApi, getPaperPreviewInfoApi } from '../api/paper';
import { ConfirmTip } from '@/components/confirm';
import Toast from '@/components/Toast';
// import _ from 'lodash';
import moment from 'moment';
import {
    submitLoadingModal,
    examSubmitFailedModal,
    examSubmitRepeatModal,
    examSubmitSuccessModal,
    examTimeFinishModal
} from '@/page/Exam/component/loadingModal';
import { Modal } from 'antd';
import { delay } from '@/utils/utils';
import { Storage } from '@/utils/Storage';
class Paper {
    constructor() {
        makeObservable(this);
    }
    @observable onlyShowError = false;
    @action
    setOnlyShowError = (v) => {
        this.onlyShowError = v;
    };

    @observable countdownTimer = null;

    @action
    setCountdownTimer = (v) => {
        this.countdownTimer = v;
    };

    @observable loading = true;
    @action
    setLoading = (v) => {
        this.loading = v;
    };

    @observable autoSubmitResult = 'unset'; // success  fail unset  notInTime
    @action
    setAutoSubmitResult = (v) => {
        this.autoSubmitResult = v;
    };

    @observable isSubmit = false; // 试卷是否提交
    @action
    setIsSubmit = (v) => {
        this.isSubmit = v;
    };

    @observable TextTipsVisiable = false;
    @action
    setTextTipsVisiable = (v) => {
        this.TextTipsVisiable = v;
    };
    @observable textTipsMsg = '';
    @action
    setTextTipsMsg = (v) => {
        this.textTipsMsg = v;
    };

    @observable
    user_answer_list = []; //用户所答答案

    @observable
    correct_answer_list = []; //题目正确答案及解析

    @observable answer_sheet_list = [];
    @action
    setAnswerSheetList = (v) => {
        this.answer_sheet_list = v;
    };

    @observable questionList = [];
    @observable paperInfo = {}; //试卷详情

    @observable examInfo = {};

    @observable examInfoTitle = '';

    @observable
    time = 0;

    @action
    setTime(time) {
        this.time = time;
    }
    @observable
    intervalId = null;

    @action
    setIntervalId(intervalId) {
        this.intervalId = intervalId;
    }

    @observable
    countDownFlag = false; //true:倒计时结束；false：倒计时未结束

    @action
    setCountDownFlag(countDownFlag) {
        this.countDownFlag = countDownFlag;
    }

    @action
    startTimer() {
        if (this.time <= 0) {
            this.setCountDownFlag(true);
        } else {
            this.setCountDownFlag(false);
        }
        this.intervalId = setInterval(() => {
            this.setTime(this.time - 1);
            // this.time -= 1;
            if (this.time <= 0) {
                this.setCountDownFlag(true);
                this.setComeInExamFlag(2);
                this.stopTimer();
            } else {
                this.setCountDownFlag(false);
            }
        }, 1000);
    }

    @action
    stopTimer() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        this.intervalId = null;
    }
    @action
    resetTimer(timeMills) {
        this.stopTimer();
        this.setTime(timeMills / 1000);
    }

    @observable
    comeInExamFlag = 0; //0：考试结束，不能进入；1：考试时间未到，但在30分钟内，显示倒计时；2：考试进行中,3：考试时间未到，但在30分钟外，不显示倒计时；

    @action
    setComeInExamFlag(comeInExamFlag) {
        this.comeInExamFlag = comeInExamFlag;
    }

    @observable
    limitTime = false; //true:限制时间；false：不限制时间
    @action
    setLimitTime(limitTime) {
        this.limitTime = limitTime;
    }

    startExamHandler = async (params) => {
        const { code, msg, data, success } = await startExamApi(params);
        if (code === '00000') {
            this.examInfo = data;
            this.examInfoTitle = data?.title;
            await this.getQuestionList(data);
            await this.getUserAnswerList(params);
        } else {
            Toast.error(msg);
        }
        return { code, msg, data, success };
    };

    getQuestionList = async (data) => {
        try {
            const obs = await obsDownloadFile(data.bucket_name, data.file_name);
            runInAction(() => {
                this.paperInfo = obs;
                this.questionList = obs.paper_module;
                this.answer_sheet_list = this.getAnswerSheetList('answer');
            });
        } catch (err) {
            this.paperInfo = {};
            this.questionList = [];
        }
    };

    getPaperPreviewList = async (paper_id, template_id, business_id) => {
        const examInfoResult = await getPaperPreviewInfoApi({ template_id, business_id });
        if (examInfoResult.success) {
            runInAction(() => {
                this.examInfo = examInfoResult.data;
                this.examInfoTitle = examInfoResult.data?.title;
            });
        }
        const { success, data } = await getPaperPreviewApi(paper_id);
        if (success) {
            runInAction(() => {
                this.paperInfo = data;
                this.questionList = data.paper_module;
                this.answer_sheet_list = this.getAnswerSheetList('answer');
            });
        } else {
            this.paperInfo = {};
            this.questionList = [];
        }
        return { success, data };
    };

    //查询试卷信息
    getExamInfo = async (params) => {
        const { code, msg, data } = await requestExamPracticeApi(params);
        if (code === '00000') {
            this.examInfo = this.successData(data);
            this.setLoading(false);
        } else {
            Toast.error(msg);
        }
        return { code, msg, data };
    };
    @action
    successData(responseData) {
        let nowTime = responseData.now_time ? responseData.now_time : -1,
            startTime = responseData.start_time ? responseData.start_time : 0,
            endTime = responseData.end_time ? responseData.end_time : 0;

        if (startTime > 0 && endTime > 0) {
            this.setLimitTime(true);
        } else {
            this.setLimitTime(false);
        }
        if (this.limitTime) {
            if (nowTime < startTime) {
                //不能进入考试，显示倒计时
                if (this.countDownFlag) {
                    this.setComeInExamFlag(2);
                } else {
                    if (startTime - nowTime <= 30 * 60 * 1000) {
                        this.setComeInExamFlag(1);
                        this.resetTimer(startTime - nowTime);
                        this.startTimer();
                    } else {
                        this.setComeInExamFlag(3);
                    }
                }
            } else if (nowTime > endTime) {
                //不能进入考试，考试已结束
                this.setComeInExamFlag(0);
            } else {
                //考试进行中
                this.setComeInExamFlag(2);
            }
        } else {
            this.setComeInExamFlag(2);
        }
        return responseData;
    }

    // 获取答题卡数据 analysis/answer
    getAnswerSheetList = (type) => {
        let result = { '-1': { module_id: '-1', children: [] } },
            cur_module_id = '';
        const module_list = this.paperInfo.paper_module || [];
        module_list.forEach((ele) => {
            if (ele.type === 2) {
                result[ele.module_id] = { ...ele, children: [] };
            }
        });

        module_list.forEach((ele, index) => {
            if (index === 0 && ele.type === 1) {
                cur_module_id = '-1';
            }
            if (index > 0 && module_list[index - 1].type === 2) {
                cur_module_id = module_list[index - 1].module_id;
            }
            if (cur_module_id && ele.type === 1) {
                const hasAnswer = this.user_answer_list.filter((item) => {
                    return item.question_id === ele.question_id;
                });
                if (type === 'answer') {
                    ele.hasAnswer = Boolean(hasAnswer.length);
                    ele.user_anaswer = hasAnswer[0]?.answers;
                    ele.doc_list = hasAnswer[0]?.doc_list;
                } else {
                    const isTrue = this.user_answer_list.filter((item) => {
                            return item.question_id === ele.question_id && item.review_type === 1 && item.correct;
                        }),
                        isReview = this.user_answer_list.filter((item) => {
                            return item.question_id === ele.question_id && item.review_type === 2;
                        });
                    ele.isTrue = Boolean(isTrue.length);
                    ele.isReview = Boolean(isReview.length);
                    ele.user_anaswer = hasAnswer[0]?.answers;
                    ele.user_anaswer_Obj = hasAnswer.length ? hasAnswer[0] : {};
                }
                result[cur_module_id].children.push(toJS(ele));
            }
        });
        let arr = [];
        for (let key in result) {
            arr.push(result[key]);
        }
        return arr;
    };

    //答题中获取答案
    getUserAnswerList = async (params) => {
        const { code, msg, data } = await getMyAnswerApi(params);
        if (code === '00000') {
            runInAction(() => {
                this.user_answer_list = data || [];
                this.answer_sheet_list = this.getAnswerSheetList('answer');
            });
            return true;
        }
        runInAction(() => {
            this.user_answer_list = [];
        });
        Toast.error(msg);
        return false;
    };

    //提交答案
    setUserAnswer = async (param) => {
        const { code, msg } = await setAnswerApi({ ...param });
        if (code === '00000') {
            if (param.answers?.length || param.doc_list?.length) {
                //1、从学员答案中查找是否之前已答题
                let is_hasAnswer = this.user_answer_list.filter((item) => {
                    return item.question_id === param.question_id;
                });
                //保存答案成功，如之前答题，更新最新答案
                if (is_hasAnswer.length) {
                    this.user_answer_list.forEach((ele) => {
                        if (ele.question_id === param.question_id) {
                            ele.answers = Object.assign(param.answers);
                            ele.doc_list = Object.assign(param?.doc_list || []);
                        }
                    });
                } else {
                    this.user_answer_list.push({
                        question_id: param.question_id,
                        answers: param.answers,
                        doc_list: param.doc_list
                    });
                }
            } else {
                this.user_answer_list = this.user_answer_list.filter((item) => item.question_id !== param.question_id);
            }
            return true;
        }
        Toast.error(msg);
        return false;
    };
    onCancel = () => {};

    //交卷 （退出/交卷）
    submitExam = async (params, extraFlag, isFromConfirm = false) => {
        //未到最短答题时长 - 提示
        //有必答题未完成 - 提示
        let has_un_require_answer = false,
            has_un_isSub = false;
        this.questionList.forEach((ele) => {
            const hasAnswer = this.user_answer_list.filter((item) => {
                return item.question_id === ele.question_id;
            });
            if (hasAnswer.length === 0 && ele.require_question) {
                has_un_require_answer = true;
            }
        });

        if (has_un_require_answer) {
            this.textTipsMsg = '请检查答题卡，必答题未答完，暂无法交卷～';
            this.setTextTipsVisiable(true);
            return;
        }

        // // 通过验证 - 确认弹窗
        let message = '您已完成作答，确认要交卷么？';
        // //有题目未答-二次确认
        this.questionList.forEach((ele) => {
            if (ele.type === 1) {
                const hasAnswer = this.user_answer_list.filter((item) => {
                    return item.question_id === ele.question_id;
                });
                if (extraFlag === 1 || extraFlag === '1') {
                    if (hasAnswer.length === 0 || (hasAnswer[0]?.answers?.length === 0 && hasAnswer[0]?.doc_list?.length === 0)) {
                        message = '您还有题目未答，确认要交卷么？';
                    }
                    if (hasAnswer[0]?.doc_list?.length > 0) {
                        hasAnswer[0]?.doc_list.map((v) => {
                            if (v.status && v.status === 'active') {
                                Toast.error('文件上传中，不可提交');
                                has_un_isSub = true;
                                return false;
                            }
                            if (v.status && v.status === 'exception') {
                                Toast.error('存在文件上传失败，不可提交');
                                has_un_isSub = true;
                                return false;
                            }
                        });
                    }
                } else {
                    if (hasAnswer.length === 0) {
                        message = '您还有题目未答，确认要交卷么？';
                    }
                }
            }
        });
        if (!has_un_isSub) {
            if (isFromConfirm) {
                this.updateExamState(params);
                return false;
            }
            ConfirmTip({
                title: message,
                onOk: this.updateExamState.bind(null, params)
            });
            has_un_isSub = false;
        }
    };

    updateExamState = async (data) => {
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
        }
        Modal.destroyAll();
        let userInfoStr = Storage.get('userInfo');
        let userInfo = JSON.parse(userInfoStr);
        Storage.remove(`${userInfo?.id}-${data?.business_id}-cutScreenNum`);
        submitLoadingModal();
        try {

            const res=await Promise.all([
                submitExamApi(data),
                delay(1000)
            ]);
            Modal.destroyAll();
            const{code}=res[0] ? res[0] : {};
            if (code === '00000') {
                // Toast.info('提交成功');
                examSubmitSuccessModal(()=>{
                    this.closeBrownTab(data);
                    Modal.destroyAll();
                });

            } else if (code === 'A2000' || code === 'A2002') {
                examSubmitRepeatModal(data.template_id,()=>{
                    this.closeBrownTab(data);
                    Modal.destroyAll();
                });
            } else {
                examSubmitFailedModal(()=>{
                    this.closeBrownTab(data);
                    Modal.destroyAll();
                });
            }
        }catch (e) {
            Modal.destroyAll();
            examSubmitFailedModal(()=>{
                this.closeBrownTab(data);
                Modal.destroyAll();
            });
        }
    };

    //倒计时结束自动交卷自动交卷
    autoSubmitExam = async (data) => {
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
        }
        examTimeFinishModal();
        await delay(1500);
        Modal.destroyAll();
        submitLoadingModal();
        try {
            const res=await Promise.all([
                submitExamApi(data),
                delay(1000)
            ]);
            Modal.destroyAll();
            const{code}=res[0] ? res[0] : {};
            // if (code === '00000') {
            //     //自动交卷成功提示
            //     this.textTipsMsg = '考试时间已结束，已为您自动交卷了～';
            //     this.setTextTipsVisiable(true);
            //     this.setAutoSubmitResult('success');
            //     this.setIsSubmit(true);
            // } else {
            //     //自动交卷失败提示
            //     this.textTipsMsg = '考试时间已结束，自动交卷失败！';
            //     this.setTextTipsVisiable(true);
            //     this.setAutoSubmitResult('fail');
            // }
            if (code === '00000') {
                //自动交卷成功提示
                examSubmitSuccessModal(() => {
                    //自动交卷成功提示
                    // this.textTipsMsg = '考试时间已结束，已为您自动交卷了～';
                    // this.setTextTipsVisiable(true);
                    // this.setAutoSubmitResult('success');

                    this.setIsSubmit(true);
                    this.closeBrownTab(data);
                    Modal.destroyAll();
                });
            } else if (code === 'A2000' || code === 'A2002') {
                //重复提交
                examSubmitRepeatModal(data.template_id,() => {
                    //自动交卷失败提示
                    // this.textTipsMsg = '考试时间已结束，自动交卷失败！';
                    // this.setTextTipsVisiable(true);
                    // this.setAutoSubmitResult('fail');
                    this.closeBrownTab(data);
                    Modal.destroyAll();
                });
            } else {
                //自动交卷失败提示
                examSubmitFailedModal(()=>{
                    //自动交卷失败提示
                    // this.textTipsMsg = '考试时间已结束，自动交卷失败！';
                    // this.setTextTipsVisiable(true);
                    // this.setAutoSubmitResult('fail');
                    this.closeBrownTab(data);
                    Modal.destroyAll();
                });
            }
        }catch (e) {
            Modal.destroyAll();
            examSubmitFailedModal(()=>{
                //自动交卷失败提示
                // this.textTipsMsg = '考试时间已结束，自动交卷失败！';
                // this.setTextTipsVisiable(true);
                // this.setAutoSubmitResult('fail');
                this.closeBrownTab(data);
                Modal.destroyAll();
            });
        }

    };

    getTimeOut = (data, nowTime) => {
        let temNowTime = nowTime || data.now_time,
            //当考试结束时间-首次进入作答时间>最长作答时长（60分钟）;   剩余时间 = 最长作答时长-（当前时间 -首次进入作答时间）
            end_time = data.end_time > 0 ? data.end_time : moment('2099-12-31 12:00:00').valueOf();

        if (end_time - data.enter_time > data.duration * 60 * 1000) {
            return Math.floor((data.duration * 60 * 1000 - (temNowTime - data.enter_time)) / 1000);
        }
        // 当考试结束时间-首次进入作答时间<最长作答时长（60分钟）;  剩余时间 = 考试结束时间-当前时间
        return Math.floor((end_time - temNowTime) / 1000);
    };

    //关闭浏览器页面
    closeBrownTab = (data) => {
        const opener = window.opener;
        if (opener) {
            switch (data.template_id) {
                case 102:
                case '102': //考试
                    opener.postMessage('closeExamPage', '*');
                    break;
                case 105:
                case '105': //作业
                    opener.postMessage('closeSchoolAsPage', '*');
                    break;
                case 106:
                case '106': //研修成果
                    opener.postMessage('closeTrainingAcPage', '*');
                    break;
            }
        }
        window.close();
    };

    //获取答案解析
    getAnswerInfo = async (params) => {
        const { code, msg, data } = await getAnswerInfoApi(params);
        if (code === '00000') {
            runInAction(async () => {
                this.examInfoTitle = data?.title;
                this.examInfo = data;
                this.user_answer_list = data.user_answer_list?.length > 0 ? data.user_answer_list : [];
                this.correct_answer_list = data.answer_list?.length > 0 ? data.answer_list : [];
                await this.getQuestionList(data);
                this.answer_sheet_list = this.getAnswerSheetList('analysis');
            });
            return true;
        }
        runInAction(() => {
            this.user_answer_list = [];
            this.answer_sheet_list = [];
            this.correct_answer_list = [];
        });
        Toast.error(msg);
        return false;
    };

    @action
    clear = () => {
        this.examInfo = {};
    };
}
export default new Paper();
